import React from 'react';
import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { CATEGORY_ICON_MAP, CategoryName } from '../Workflow/Workflow.meta';

interface RespondentDTO {
  name: string;
  isPartner: boolean;
}

interface CategoryDTO {
  id: CategoryName;
  name: CategoryName;
  description: string;
  fulfillment: number;
}

export interface CategoryType extends CategoryDTO {
  icon: React.FC;
}

interface WorkflowDTO {
  respondents: RespondentDTO[];
  fulfillmentCategories: CategoryType[];
  isRetakingAssessment: boolean;
}

export interface PulseCheckWorkflow extends WorkflowDTO {
  categories: CategoryType[];
}

interface FetcherParams {
  clientId: string;
}

export const fetchWorkflow = async ({ clientId }: FetcherParams): Promise<PulseCheckWorkflow> => {
  const data: WorkflowDTO = await authFetch(
    urlWithParams('/Consumer/PulseCheckSupport', { clientId }),
  );

  return {
    ...data,
    categories: data.fulfillmentCategories.map(category => ({
      ...category,
      icon: CATEGORY_ICON_MAP[category.id],
    })),
  };
};

interface QueryParams {
  clientId: string;
}

export const useWorkflowQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.workflow(clientId),

    () => fetchWorkflow({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
